import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQuery } from './api/baseApiConfig';
import config from '../config';

import { Instrument } from '../types/instrument';
import { Scenario } from 'types/scenario';
import { isNil } from 'lodash';

type FetchInstruments = void;
type FetchScenario = {
	companyId: string | null;
	businessId?: string | null;
};

const Tags = {
	Instrument: 'instrument',
	InstrumentCategory: 'instrumentCategory',
	Scenario: 'scenario',
};

export const instrumentV2Api = createApi({
	reducerPath: 'instrumentV2',
	baseQuery: createBaseQuery(`${config.APIM_BASE_URL}/${config.INSTRUMENT_API_URL}`),
	tagTypes: [Tags.Instrument, Tags.Scenario],
	endpoints: builder => ({
		fetchInstrumentsByCompany: builder.query<Instrument[], FetchInstruments>({
			query: () => {
				return {
					method: 'GET',
					url: `/instruments`,
				};
			},
			providesTags: (_data, _error, _params) => {
				return [{ type: Tags.Instrument, id: 'LIST' }];
			},
		}),
		fetchScenario: builder.query<Scenario, FetchScenario>({
			query: ({ companyId, businessId }) => {
				if (isNil(companyId)) {
					throw new Error('parameter error');
				}
				return {
					method: 'GET',
					url: businessId ? `/scenario/main/${companyId}?businessId=${businessId}` : `/scenario/main/${companyId}`,
				};
			},
			providesTags: (_data, _error, params) => {
				return [{ type: Tags.Scenario, id: params?.companyId ?? '' }];
			},
		}),
	}),
});

export const { useFetchInstrumentsByCompanyQuery, useFetchScenarioQuery } = instrumentV2Api;
